// @wc-ignore-file
import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
	clientPrefix: "VITE_",
	client: {
		VITE_CONVEX_URL: z.url(),
		VITE_WORKOS_CLIENT_ID: z.string().startsWith("client_"),
		VITE_WORKOS_REDIRECT_URI: z.url(),
		VITE_OMISE_PUBLIC_KEY: z.string().startsWith("pkey_"),
		VITE_SENTRY_DSN: z.url().optional(),
	},
	shared: {
		MODE: z.enum(["development", "production", "test"]).default("production"),
	},
	runtimeEnv: import.meta.env,
	// Skip validation under bun test — runtime envs aren't required and the test
	// runner doesn't load .env, so validation fails CI even when the code under
	// test never reads env values.
	skipValidation: process.env.NODE_ENV === "test",
});
